import React from 'react';
import useDefineDevice from '@Utils/core/hooks/useDefineDevice';
import DownloadButtonMobile from './mobile';
import DownloadButton from './desktop';

interface OwnProps {
  appStoreUrl: string;
  googlePlayUrl: string;
  downloadLink: string;
  downloadText: string;
}

const DownloadButtonAndStoreSimple: ReactFCWithChildren<OwnProps> = (props) => {
  const { isMobileDevice } = useDefineDevice();

  const { appStoreUrl, googlePlayUrl } = {
    appStoreUrl: props.appStoreUrl,
    googlePlayUrl: props.googlePlayUrl,
  };

  const downloadButton = React.useMemo(
    () =>
      props.children ? (
        props.children
      ) : (
        <DownloadButton downloadLink={props.downloadLink} download={props.downloadText} />
      ),
    [props.children, props.downloadLink, props.downloadText],
  );

  return (
    <>
      {isMobileDevice ? (
        <DownloadButtonMobile appStoreUrl={appStoreUrl} googlePlayUrl={googlePlayUrl} />
      ) : (
        downloadButton
      )}
    </>
  );
};

export default DownloadButtonAndStoreSimple;
